"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportsCardContainerTranslations = {
    "en": {
        callsInQueue: "Calls in queue",
        totalActiveCalls: "Total active calls",
        agentsLoggedIn: "Agents logged in ",
        agentsWithCustomers: "Agents with customers",
    },
    "de": {
        callsInQueue: "Anrufe in der Warteschlange",
        totalActiveCalls: "Gesamtzahl der aktiven Anrufe",
        agentsLoggedIn: "Eingeloggte Mitarbeiter ",
        agentsWithCustomers: "Mitarbeiter mit Kunden",
    },
    "nl": {
        callsInQueue: "Oproepen in de wachtrij",
        totalActiveCalls: "Totale actieve oproepen",
        agentsLoggedIn: "Agenten ingelogd ",
        agentsWithCustomers: "Agenten met klanten",
    },
    "it": {
        callsInQueue: "Chiamate in coda",
        totalActiveCalls: "Totale chiamate attive",
        agentsLoggedIn: "Agenti connessi ",
        agentsWithCustomers: "Agenti in chiamata",
    },
    "fr": {
        callsInQueue: "Appels dans la file d'attente",
        totalActiveCalls: "Nombre total d'appels actifs",
        agentsLoggedIn: "Agents connectés ",
        agentsWithCustomers: "Agents avec des clients",
    },
    "es": {
        callsInQueue: "Llamadas en cola de espera",
        totalActiveCalls: "Total de llamadas activas",
        agentsLoggedIn: "Agentes conectados ",
        agentsWithCustomers: "Agentes con clientes",
    },
    "ja": {
        callsInQueue: "キュー中の通話",
        totalActiveCalls: "アクティブな通話合計",
        agentsLoggedIn: "ログイン中のエージェント ",
        agentsWithCustomers: "カスタマー対応中のエージェント",
    },
    "en-GB": {
        callsInQueue: "Calls in queue",
        totalActiveCalls: "Total active calls",
        agentsLoggedIn: "Agents logged in ",
        agentsWithCustomers: "Agents with customers",
    },
    "ru": {
        callsInQueue: "Звонки в очереди",
        totalActiveCalls: "Всего активных звонков",
        agentsLoggedIn: "Агенты в сети ",
        agentsWithCustomers: "Агенты с клиентами",
    },
};
